// utils/fetchEmployeeImage.ts
import axios from "axios";
import { API_BASE_PATH } from "../../environment";

export const fetchEmployeeImage = async (
  empId: string,
  token: string | null,
): Promise<string> => {
  try {
    const res = await axios.get(
      `${API_BASE_PATH}/register/employee/${empId}/image?t=${Date.now()}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(res.data);
    });
  } catch (err) {
    console.error(`Failed to load image for employee ${empId}:`, err);
    return "/assets/img/defaultavatar.png";
  }
};
